<template>
  <div class="app-explained-view">
    <details>
      <summary>Alle Fragen</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-all.jpg" />
      </div>
      <div class="explanation">
        Hier kommen alle Fragen aus Grundwissen und B-Führerschein gemischt
      </div>
    </details>
    <details>
      <summary>Grundwissen</summary>
      <div class="explanation">
        Hier findest du alle Fragen aus dem Bereich Grundwissen. Du kannst auch
        nach Themengebieten lernen. Die Ziffern, zum Beispiel hinter
        Gefahrenzeichen 0/78 bedeuten, dass du zurzeit Null richtige Fragen von
        insgesamt 78 gelernt hast.
      </div>
    </details>
    <details>
      <summary>B-Führerschein</summary>
      <div class="explanation">
        Hier findest du alle Fragen aus dem Bereich B-Führerschein. Du kannst
        auch nach Themengebieten lernen. Die Ziffern, zum Beispiel hinter
        B-Rechtsvorschriften 0/100 bedeuten, dass du zurzeit Null richtige
        Fragen von insgesamt 100 gelernt hast.
      </div>
    </details>
    <details>
      <summary>5-Punkte Fragen</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-5-points.jpg" />
      </div>
      <div class="explanation">
        Die 5-Punkte Fragen werden während der Führerscheinprüfung mit der
        höchsten Punktzahl für die richtige Antwort gewertet – mit 5 Punkten.
        Diese Fragen sollte man sehr gut können, deshalb solltest du diese
        Kategorie intensiv lernen.
      </div>
    </details>
    <details>
      <summary>Schwere Fragen</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-hard.jpg" />
      </div>
      <div class="explanation">
        Hier findest du die 300 am öftesten falsch beantworteten Fragen
        zusammengefasst.
      </div>
    </details>
    <details>
      <summary>Falsche Fragen</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-wrong.jpg" />
      </div>
      <div class="explanation">
        Hier werden alle Fragen gespeichert, die du selbst falsch beantwortet
        hast, damit du sie gezielt üben kannst.
      </div>
    </details>
    <details>
      <summary>Frage suchen nach ID</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-by-id.jpg" />
      </div>
      <div class="explanation">
        Hier kannst du eine Frage mit der ID-Nummer aus deinem Kursbuch suchen.
      </div>
    </details>
    <details>
      <summary>Prüfungssimulator</summary>
      <div class="explanation-image">
        <img src="@/assets/help/menu-tests.jpg" />
      </div>
      <div class="explanation">
        Du erhältst einen Fragenmix wie bei der theoretischen
        Führerschein-Prüfung.
      </div>
    </details>
    <details>
      <summary>Alle richtigen Antworten</summary>
      <div class="explanation-image">
        <img src="@/assets/help/all-correct.jpg" />
      </div>
      <div class="explanation">
        Die Anzeige zählt alle Fragen, die du insgesamt richtig beantwortest
      </div>
    </details>
    <details>
      <summary>Tacho Mitte</summary>
      <div class="explanation-image">
        <img src="@/assets/help/Tachomitte.jpg" />
      </div>
      <div class="explanation">
        Jede Frage, die du 3x richtig beantwortest, hast du gut gelernt. Du
        erkennst deinen Lernerfolg am ansteigenden Tacho. Die Ziffern 1 bis 5
        sind Etappen Ziele. Mit jedem erreichten Ziel kannst du dein Auto
        pimpen.
      </div>
    </details>
    <details>
      <summary>Tageserfolg</summary>
      <div class="explanation-image">
        <img src="@/assets/help/Tageserfolg.jpg" />
      </div>
      <div class="explanation">
        Die Tankanzeige füllt sich, je fleißiger du übst. Sie ist mit deiner
        Tages- und Wochenstatistik verbunden.
      </div>
    </details>
    <details>
      <summary>Facebook, Instagram und Teilen</summary>
      <div class="explanation-image"><img src="@/assets/help/share.jpg" /></div>
      <div class="explanation">Teile deine Erfolge mit deinen Freunden</div>
    </details>
    <details>
      <summary>Etappenziele</summary>
      <div class="explanation-image"><img src="@/assets/help/track.png" /></div>
      <div class="explanation">
        Die Etappenziele sind mit deinem mittleren Tacho verbunden. Mit jedem
        erreichten Etappenziel kannst du dein Auto pimpen.
      </div>
    </details>
    <details>
      <summary>Auto</summary>
      <div class="explanation-image"><img src="@/assets/help/Auto.jpg" /></div>
      <div class="explanation">
        Zu Beginn kannst du dir ein Auto auswählen. Mit jedem erreichten
        Etappenziel auf deinem mittleren Tacho bekommst du ein neues Feature für
        dein Auto.
      </div>
    </details>
    <details>
      <summary>Fragen beantwortet</summary>
      <div class="explanation-image">
        <img src="@/assets/help/q-answered-chart.jpg" />
      </div>
      <div class="explanation">
        Hier ist deine persönliche Statistik deiner „Richtig“ (in blau) und
        „Falsch“ (in weiß) beantworteten Fragen.
      </div>
    </details>
    <details>
      <summary>Lernminuten pro Tag</summary>
      <div class="explanation-image">
        <img src="@/assets/help/lernminuten.jpg" />
      </div>
      <div class="explanation">
        Hier siehst du, wieviele Minuten du die letzten Tage geübt hast.
      </div>
    </details>
    <details>
      <summary>Trophäen</summary>
      <div class="explanation-image">
        <img src="@/assets/help/trophies.png" />
      </div>
      <div class="explanation">
        Wenn du einen Themenbereich komplett gelernt hast, bekommst du eine
        Trophäe. Gelernt bedeutet, dass du die Fragen 3x richtig beantwortet
        hast. Erst dann ist eine Frage verinnerlicht und zählt.
      </div>
    </details>
    <details>
      <summary>Prüfungen</summary>
      <div class="explanation-image"><img src="@/assets/help/tests.png" /></div>
      <div class="explanation">
        Wenn du dich fit genug für die Führerschein-Prüfung fühlst, kannst du im
        Prüfungssimulator die Führerschein-Prüfung üben. Hier siehst du deine
        letzten Ergebnisse.
      </div>
    </details>
    <details>
      <summary>Frage leichter verständlich</summary>
      <div class="explanation-image">
        <img src="@/assets/help/q-easy.jpg" />
      </div>
      <div class="explanation">
        Hier findest du dieselbe Frage nochmal in einer leichter verständlichen
        Erklärung. Zum besseren Verständnis ist bei manchen Fragen ein kurzes
        Video dabei. Das Video gibt den Inhalt der Frage und der Antworten
        wieder und zeigt dir auf was es ankommt. Allerdings musst du die Antwort
        selber herausfinden. Das Video gibt dir keine Antwort auf die Frage.<br />
        Wenn du die Originalfrage falsch beantwortest, rutschst du automatisch
        nach unten zu der leichter verständliche Version. Beantwortest du diese
        richtig, rutschst du wieder nach oben und kannst die Originalfrage
        ebenfalls richtig beantworten. Beantwortest du beide falsch, solltest du
        vielleicht nochmals in deinen Fahrschul-Unterlagen nachlesen
      </div>
    </details>
    <details>
      <summary>Videos zu Fragen</summary>
      <div class="explanation-image"><img src="@/assets/help/video.png" /></div>
      <div class="explanation">
        Das Video zeigt dir ganz gezielt, was die Frage aussagt und was die
        Antworten bedeuten. Das Video gibt dir keine Antwort auf die Frage. Das
        Video startet immer zuerst mit dem Fragezeichensymbol für die Frage,
        dann mit 1 bis 4 für die Reihenfolge der Antwortmöglichkeiten.
      </div>
    </details>
    <details>
      <summary>Antwortmöglichkeiten</summary>
      <div class="explanation-image">
        <img src="@/assets/help/answers.png" />
      </div>
      <div class="explanation">
        Es gibt immer vier Antwortmöglichkeiten. Tippe auf die Kästchen, um die
        richtige Antwort einzuloggen. Ob du richtig oder falsch geantwortet
        hast, erkennst du an der Farbe der Kästchen sobald du auf „Frage lösen“
        tippst. Türkis markierte Kästchen zeigen dir die richtigen Antwortfelder
        und die weißen Kästchen sind falsche Antworten. Wenn du die Frage
        richtig beantwortest, hörst du zusätzlich ein Siegerklingeln. Klicke auf
        „weiter“ um die nächste Frage zu beantworten.
      </div>
    </details>
    <div class="motivational-message">Viel Erfolg und Freude beim Lernen!</div>
  </div>
</template>

<script>
export default {
  name: "AppExplainedView",
  mounted() {
    // see https://stackoverflow.com/a/36994802/1058055
    // Fetch all the details element.
    const details = document.querySelectorAll("details");

    // Add the onclick listeners.
    details.forEach((targetDetail) => {
      targetDetail.addEventListener("click", () => {
        // Close all the details that are not targetDetail.
        details.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.app-explained-view {
  .motivational-message {
    text-align: center;
    margin: 40px auto 40px auto;
  }
  div.explanation {
    ul {
      li {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
